import approvedIconSrc from '../../assets/icons/orderStatusIcons/approved.png'
import GenericIcon from './GenericIcon'

const ApprovedIcon = ({ className }) => {
  return <GenericIcon src={approvedIconSrc} alt="Approved Icon" className={className} />
}

export default ApprovedIcon
